import { MRT_ColumnDef} from "material-react-table";
import {
  CustomSearch,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { useMemo} from "react";
import { GrupoActivo } from "@/shared/interfaces";
import { useDeleteGrupoActivos, useUpdateGrupoActivo, usefetchGrupoActivos } from "@/shared/actions/erp/activos";
import { useNavigate } from "react-router-dom";
import { useUiConfirmModalStore } from "@/store/ui";
import { hasAllPermissions, hasPermission } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";

const returnUrlGa = '/activos/grupo-activos';

export interface GrupoActivossPageInterface {}

const GrupoActivosPage: React.FC<GrupoActivossPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_grupoactivo)

  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
const setConfirmDialogIsOpen = useUiConfirmModalStore(
  s => s.setConfirmDialogIsOpen
);
  const updateGrupoActivos= useUpdateGrupoActivo({navigate,returnUrl:returnUrlGa})
  const deleteGrupoActivos = useDeleteGrupoActivos();
  const onEdit = (original: GrupoActivo) => {
    navigate(`${returnUrlGa}/editar/${original.id_grupo_activo}`);
  };
  const onDelete = (original:GrupoActivo) => {
    setConfirmDialog({
      isOpen: true,
      subtitle: '¿Está seguro que desea eliminar el grupo activo seleccionado?',
      title: 'Confirmar',
      onConfirm: () => {
        deleteGrupoActivos.mutate(original.id_grupo_activo!);
      },
      onClose() {
        setConfirmDialogIsOpen(false);
      },
    });
  }
  const columns = useMemo<MRT_ColumnDef<GrupoActivo>[]>(
    () => [
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        accessorKey: "codigo",
        header: "codigo",
        size: 200,
      },
      {
        accessorKey: "nombre",
        header: "nombre",
        size: 200,
      },
      {
        accessorKey: "anios_deprecacion",
        header: "años depreciación",
        size: 200,
      },
      {
        accessorKey: "meses_deprecacion",
        header: "meses depreciación",
        size: 200,
      },
      {
        accessorKey: "valor_deprecacion_anual",
        header: "valor deprecación anual",
        size: 200,
      },
      {
        accessorKey: "valor_deprecacion_mensual",
        header: "valor deprecación mensual",
        size: 200,
      },
      {
        accessorKey: "valor_deprecacion_diaria",
        header: "valor depreciación diaria",
        size: 200,
      },
      {
        accessorKey: "vida_util",
        header: "vida util",
        size: 200,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={grupo => {
              if (!hasPermission(PermissionsEnum.api_change_grupoactivo)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateGrupoActivos.mutate({
                    id: row.original.id_grupo_activo!,
                    data: {
                      ...row.original,
                      estado: grupo as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();


  const {
    isLoading,
    data: GrupoActivosRes,
    isRefetching,
  } = usefetchGrupoActivos({
    codigo: searchTerm,
    
  });

  return (
<>
<SingleTableBoxScene title="Grupo ACT" urlRedirect={`${returnUrlGa}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_grupoactivo)}>
      <CustomSearch onChange={onChangeFilter} cleanFilter={cleanFilter} value={globalFilter} text="Grupo activos" />
        <GeneralTable<GrupoActivo>
          columns={columns}
          data={GrupoActivosRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={GrupoActivosRes?.data?.count}
          enableColumnActions={hasAllPermissions([
            PermissionsEnum.api_change_grupoactivo,
          ])}
          // // actions
          onEdit={onEdit}
          canEdit={hasAllPermissions([
            PermissionsEnum.api_change_grupoactivo,
          ])}
          canDelete
          onDelete={onDelete}
        />
        </SingleTableBoxScene>
   </>
  );
}

export default GrupoActivosPage;